import {  Component,  OnInit,  NgZone} from '@angular/core';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import {  InteractionService} from '../interaction.service';
import {  Message} from '@angular/compiler/src/i18n/i18n_ast';
import {  AppDataServiceService} from '../app-data-service.service';
import {  LeftAsideService} from 'src/app/leftAside/left-aside.service'
import {  LeftThoughRightService} from 'src/app/leftAside/left-though-right.service'

@Component({
  selector: 'app-productivity',
  templateUrl: './productivity.component.html',
  styleUrls: ['./productivity.component.css']
})
export class ProductivityComponent implements OnInit {
  private chart: am4charts.XYChart;
  private barChart1: am4charts.XYChart;
  productivity;
  title;
  showThisYear;
  showZoomGraph:boolean = false;
  showZoomGraph2 = false;
  showZoomGraph1 = false;
  showZoomGraph3 = false;
  showZoomGraph4 = false;
  showZoomGraph5 = false;
  flag:any;
  
  data:any;
  //drilled_productivity
  constructor(
      private zone: NgZone,
      private _interactionService: InteractionService,
      private _getLiveDataForCharts: AppDataServiceService,
      private _leftAsideService: LeftAsideService,
      
      private _networkService: LeftThoughRightService) {}

  ngAfterViewInit() {
      this.getliveChartsData();

  }
  AddOverlay(data){
     this.flag =  data.split("_");
 //alert(data);
      this.showZoomGraph = true;
      if(data=="graph_1"){
         this.showZoomGraph2 = true;
      }
      if(data=="graph_2"){
       this.showZoomGraph1 = true;
       }
       if(data=="graph_3"){
        this.showZoomGraph4 = true;
        this.showZoomGraph5 = true;
    }
    if(data=="graph_4"){
        this.showZoomGraph3 = true;
        this.showZoomGraph5 = true;
      }
      if(data=="graph_5"){
        this.showZoomGraph4 = true;
        this.showZoomGraph3 = true;
      }

  }

  removeOverlay(){
    this.showZoomGraph= false;
    this.showZoomGraph2 = false;
    this.showZoomGraph1 = false;
    this.showZoomGraph3 = false;
    this.showZoomGraph4 = false;
    this.showZoomGraph5 = false;
  }
  ngOnInit() {
      this.productivity = false;
      this.showThisYear = "barMonthlyThisConsumption";
    //  console.log(this.dates.getdate.subscribe(newDate=>this.newDate = newDate));
  }

  showproductivity() {
      console.log('yes');
      this.productivity = false;
  }
  ngOnDestroy() {
      this.zone.runOutsideAngular(() => {
          if (this.chart) {
              this.chart.dispose();
          }
      });
  }
  drillDown(data) {
      this.productivity = true;
      console.log('drilldown', data)
      this.generateEnergyAllGroupCharts(data);
      /*this._leftAsideService.callComponentMethod(
    {
      data:data,
      type:data.type
  });
*/
  }

  drillDownProduction(data) {

      if (data.type == 'monthly') {
          this.drillDailyProduction(data);
      } else if (data.type == 'daily') {
          this.drillHourlyProduction(data);
      }
  }

  drillDailyProduction(data) {
      return this._networkService.getDailyProduction(data).subscribe(
          data => this.genrateProductivityProductionGraph_4(data['data'].linechart),
          error => console.error(error)
      );
  }

  drillHourlyProduction(data) {
      return this._networkService.getHourlyProduction(data).subscribe(
          data => this.genrateProductivityProductionGraph_3(data['data'].linechart),
          error => console.error(error)
      );
  }

  drillDownPerformance(data) {
      console.log(data)
      if (data.type == 'monthly') {
          this.drillDailyPerformance(data);
      } else if (data.type == 'daily') {
          this.drillHourlyPerformance(data);
      }
  }

  drillDailyPerformance(data) {
      return this._networkService.getDailyPerformance(data).subscribe(
          data => this.genrateProductivityPerformanceGraph_4(data['data'].linechart),
          error => console.error(error)
      );
  }

  drillHourlyPerformance(data) {
      return this._networkService.getHourlyPerformance(data).subscribe(
          data => this.genrateProductivityPerformanceGraph_3(data['data'].linechart),
          error => console.error(error)
      );
  }



  effAllMachine(data) {
      let obj = this;
      // Create chart instance
      let chart = am4core.create("effAllMachine", am4charts.XYChart);
      // Add data
      chart.data = data;
      
      /*ar label = chart.chartContainer.createChild(am4core.Label);
      label.text = " Efficiency and Machine Performance Graph for Data";
      label.align = "center";*/
      let title = chart.titles.create();
      title.text = `Efficiency and Machine Performance for date : ${data[0].date}`;
      title.fontSize = 14;
      title.marginBottom = 10;

      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.renderer.labels.template.rotation = -40;
      categoryAxis.dataFields.category = "name";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      //categoryAxis.renderer.fontWeight = "400";
      categoryAxis.renderer.fontSize = 10;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = "Miutes";
      valueAxis.min = 0;
      valueAxis.fontSize = 10;
      valueAxis.max = 1440;
      valueAxis.strictMinMax = true;
      valueAxis.calculateTotals = true;


      let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis2.title.text = "Efficiency";
      valueAxis2.renderer.opposite = true;
      valueAxis2.fontSize = 10;
      chart.legend = new am4charts.Legend();
      chart.legend.useDefaultMarker = true;
      
      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 14;
      markerTemplate.height = 14;
      chart.legend.fontSize =14;
      // Create series
      function createSeries(field, data, color) {
         console.log(color);
          // Set up series
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.name = data;
          series.dataFields.valueY = field;
          series.dataFields.categoryX = "name";
          //series.sequencedInterpolation = true;
          series.fill = am4core.color(color);
          //series.dataFields.valueYShow = "totalPercent";
          series.columns.template.events.on("hit", function(ev) {
              data = ev.target.dataItem.dataContext;
              obj.drillDown(data);
          }, this);

          // Make it stacked
          series.stacked = true;

          // Configure columns
          series.columns.template.width = am4core.percent(90);
          series.tooltipText = "{legendSettings.labelText}: {valueY}";

         //series.columns.template.alwaysShowTooltip = true;
          
          series.legendSettings.labelText = data;
          series.legendSettings.valueText = "{valueY.close}";
          series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
          if (chart.series.length > 4) {
            series.hide(0);
          }
          // Add label
          /* var labelBullet = series.bullets.push(new am4charts.LabelBullet());
           labelBullet.label.text = "{valueY}";
           labelBullet.locationY = 0.5;*/

          return series;
      }
      // Create series
      function createSeries2(field, data, ValueAxis2, color) {
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.name = data;
          series.dataFields.valueY = field;
          series.dataFields.categoryX = "name";
          series.fill = am4core.color(color);
          //series.sequencedInterpolation = true;
          
          // Make it stacked
          // series.stacked = true;
          series.clustered = false;
          series.yAxis = ValueAxis2;
          // Configure columns
          series.columns.template.width = am4core.percent(40);
           series.tooltipText = "{legendSettings.labelText}: {valueY}";
          series.columns.template.events.on("hit", function(ev) {
              let data = ev.target.dataItem.dataContext;
              obj.drillDown(data);
          }, this);

          // Add label
          /*var labelBullet = series.bullets.push(new am4charts.LabelBullet());
          labelBullet.label.text = "{''}";
          labelBullet.locationY = 0.5;*/
          series.legendSettings.labelText = data;
          series.legendSettings.valueText = "{valueY.close}";
          series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
          if (chart.series.length > 4) {
            series.hide(0);
          }

          return series;
      }
          createSeries("running_time", "Running time", '#018101');
          createSeries("off_time", "Off time", '#ff0001');
          createSeries("idle_time", "Idle_time", '#ffa402');
          createSeries2("efficiency", "Efficiency", valueAxis2, '#bbf4b9');
          //
          // Legend
        
          chart.cursor = new am4charts.XYCursor();
          chart.cursor.xAxis = categoryAxis;
         // chart.cursor.lineX.disabled = true;
          //chart.cursor.lineY.disabled = true;




  }
  prodAllmachine(data) {
      let obj = this;
      let chart = am4core.create("prodAllmachine", am4charts.XYChart);
      // Add percent sign to all numbers
      //chart.numberFormatter.numberFormat = "#.#'%'";
     // Add data
      chart.data = data;
      let title = chart.titles.create();
      title.text = `kWh and Machine Productoin details for :${data[0].date}`;
      title.fontSize = 14;
      title.marginBottom = 10;



      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "name";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.rotation = -40;
      categoryAxis.renderer.fontSize = 10;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = "kWh ";
      valueAxis.fontSize = 10;
      //chart.legend.fontSize =14;

      let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis2.title.text = "Production";
      // valueAxis2.title.fontWeight = 800;
      valueAxis2.renderer.opposite = true;
      valueAxis2.fontSize = 10;
      // Create series
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "kwh";
      series.dataFields.categoryX = "name";
      series.name = 'kWh';

      series.clustered = false;
      series.tooltipText = " {legendSettings.labelText}: [bold]{valueY}[/]";
      series.yAxis = valueAxis;
      series.fill = am4core.color('#ff0002');
      series.legendSettings.labelText = 'kWh';
      series.legendSettings.valueText = "{valueY.close}";
      series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";

      series.columns.template.events.on("hit", function(ev) {
          let data = ev.target.dataItem.dataContext;
          // this.drillDown(data);
          obj.drillDown(data);
      }, this);

      let series2 = chart.series.push(new am4charts.ColumnSeries());
      series2.dataFields.valueY = "production";
      series2.name = 'Production';
      series2.dataFields.categoryX = "name";
      series2.clustered = false;
      series2.columns.template.width = am4core.percent(40);
      series2.tooltipText = " {legendSettings.labelText} : [bold]{valueY}[/]";
      series2.yAxis = valueAxis2;
      series2.fill = am4core.color('#5c54ec');
      series2.columns.template.events.on("hit", function(ev) {
          let data = ev.target.dataItem.dataContext;
          obj.drillDown(data);
      }, this);
      series2.legendSettings.labelText = "Production";
      series2.legendSettings.valueText = "{valueY.close}";
      series2.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.lineX.disabled = true;
      chart.cursor.lineY.disabled = true;
      chart.legend = new am4charts.Legend();
      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 14;
      markerTemplate.height = 14;
      chart.legend.fontSize =14
      
      

  }

  /*getSourceMessage(){
    console.log("hello");
      this._interactionService.headerMeassage$
      .subscribe(
        message =>{
          alert(message); 
        }
      )
  }*/

  /*genrateProductivityProductionGraph_1(data) {
      let chart = am4core.create("pieEnergyConsumption", am4charts.PieChart);
      chart.data = [{
          "country": "Lithuania",
          "litres": 501.9
      }, {
          "country": "Czechia",
          "litres": 301.9
      }, {
          "country": "Ireland",
          "litres": 201.1
      }, {
          "country": "Germany",
          "litres": 165.8
      }, {
          "country": "Australia",
          "litres": 139.9
      }, {
          "country": "Austria",
          "litres": 128.3
      }, {
          "country": "UK",
          "litres": 99
      }, {
          "country": "Belgium",
          "litres": 60
      }, {
          "country": "The Netherlands",
          "litres": 50
      }];

      // Add and configure Series
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "litres";
      pieSeries.dataFields.category = "country";
      pieSeries.slices.template.stroke = am4core.color("#fff");
      pieSeries.slices.template.strokeWidth = 2;
      pieSeries.slices.template.strokeOpacity = 1;

      // This creates initial animation
      pieSeries.hiddenState.properties.opacity = 1;
      pieSeries.hiddenState.properties.endAngle = -90;
      pieSeries.hiddenState.properties.startAngle = -90;
  }*/

  genrateProductivityProductionGraph_2(data) {
    console.log(data)
    console.log("production");
      let chart = am4core.create("barMonthlyThisConsumption", am4charts.XYChart);
      let obj = this;
      // Add percent sign to all numbers
      //chart.numberFormatter.numberFormat = "#.#'%'";

      // Add data
      chart.data = data;

      let title = chart.titles.create();
      title.text = ` Monthly kWh and Machine Productoin details for year :${data[0].year}`;
      title.fontSize = 14;
      title.marginBottom = 10;

      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "month_name";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.rotation = -40;
      categoryAxis.renderer.fontSize = 10;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = "kWh ";
      //valueAxis.title.fontWeight = 800;
      valueAxis.fontSize = 10;


      let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis2.title.text = "Production";
      // valueAxis2.title.fontWeight = 800;
      valueAxis2.renderer.opposite = true;
      valueAxis2.fontSize = 10;

      // Create series
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "kwh";
      series.dataFields.categoryX = "month_name";
      series.name = 'kWh';

      series.clustered = false;
      series.tooltipText = " {legendSettings.labelText} : {valueY}[/]";
      series.yAxis = valueAxis;
      series.fill = am4core.color('#EE5C4D');
      series.legendSettings.labelText = 'kWh';
      series.legendSettings.valueText = "{valueY.close}";
      series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";

      series.columns.template.events.on("hit", function(ev) {
          let data = ev.target.dataItem.dataContext;
          // this.drillDown(data);
          obj.drillDownProduction(data);
      }, this);

      let series2 = chart.series.push(new am4charts.ColumnSeries());
      series2.dataFields.valueY = "production";
      series2.name = 'Production';
      series2.dataFields.categoryX = "month_name";
      series2.clustered = false;
      series2.columns.template.width = am4core.percent(40);
      series2.tooltipText = " {legendSettings.labelText} : {valueY}[/]";
      series2.yAxis = valueAxis2;
      series2.fill = am4core.color('#5D53EC');
      series2.legendSettings.labelText = 'production';
      series2.legendSettings.valueText = "{valueY.close}";
      series2.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
      series2.columns.template.events.on("hit", function(ev) {
          let data = ev.target.dataItem.dataContext;
          obj.drillDownProduction(data);
      }, this);

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.lineX.disabled = true;
      chart.cursor.lineY.disabled = true;
      chart.legend = new am4charts.Legend();
      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 14;
      markerTemplate.height = 14;
      chart.legend.fontSize =14
  }
  genrateProductivityProductionGraph_3(data) {
      let chart = am4core.create("lineChartHrConsumption", am4charts.XYChart);
      let obj = this;
     
      console.log("hel");
      // Add data
      chart.data = data;

      let title = chart.titles.create();
      title.text = ` Hourly kWh and Machine Productoin details for date :${data[0].date}`;
      title.fontSize = 14;
      title.marginBottom = 10;
     

      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "hour";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      //categoryAxis.renderer.labels.template.rotation = 90;
      categoryAxis.renderer.fontSize = 10;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = "kWh";
      //valueAxis.title.fontWeight = 800;
      valueAxis.fontSize = 10;

      let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis2.title.text = "Production";
      // valueAxis2.title.fontWeight = 800;
      valueAxis2.renderer.opposite = true;
      valueAxis2.fontSize = 10;

      // Create series
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "kwh";
      series.dataFields.categoryX = "hour";
      series.name = 'kWh';

      series.clustered = false;
      series.tooltipText = " {legendSettings.labelText}:{valueY}[/]";
      series.yAxis = valueAxis;
      series.fill = am4core.color('#EE5C4D');
      series.legendSettings.labelText = "kWh";
      series.legendSettings.valueText = "{valueY.close}";
      series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
      series.columns.template.events.on("hit", function(ev) {
          let data = ev.target.dataItem.dataContext;
          // this.drillDown(data);
          //obj.drillDown(data);
      }, this);



      let series2 = chart.series.push(new am4charts.ColumnSeries());
      series2.dataFields.valueY = "production";
      series2.name = 'Production';
      series2.dataFields.categoryX = "hour";
      series2.clustered = false;
      series2.columns.template.width = am4core.percent(40);
      series2.tooltipText = " {legendSettings.labelText} : {valueY}[/]";
      series2.yAxis = valueAxis2;
      series2.fill = am4core.color('#5D53EC');
      series2.columns.template.events.on("hit", function(ev) {
          let data = ev.target.dataItem.dataContext;
          //obj.drillDown(data);
      }, this);
      series2.legendSettings.labelText = "Production";
      series2.legendSettings.valueText = "{valueY.close}";
      series2.legendSettings.itemValueText = "[bold]{valueY}[/bold]";


      chart.cursor = new am4charts.XYCursor();
      chart.cursor.lineX.disabled = true;
      chart.cursor.lineY.disabled = true;
      chart.legend = new am4charts.Legend();
      series2.legendSettings.labelText = "Production";
      series2.legendSettings.valueText = "{valueY.close}";
      series2.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
   
      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 14;
      markerTemplate.height = 14;
      chart.legend.fontSize = 12 


  }
  genrateProductivityProductionGraph_4(data) {
      let chart = am4core.create("barDailyConsumptionMonthly", am4charts.XYChart);
      let obj = this;
      // Add percent sign to all numbers
      //chart.numberFormatter.numberFormat = "#.#'%'";
       console.log("jay123"); 
       console.log(data); 
      // Add data
      chart.data = data;

      let title = chart.titles.create();
      title.text = ` Daily kWh and Machine Productoin details for Month :${data[0].month_name}`;
      title.fontSize = 14;
      title.marginBottom = 10;

      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "day";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      //categoryAxis.renderer.labels.template.rotation = 90;
      categoryAxis.renderer.fontSize = 10;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = "kwh";
      //valueAxis.title.fontWeight = 800;
      valueAxis.fontSize = 10;

      /*let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.minGridDistance = 60;
        chart.dateFormatter.inputDateFormat = "dd MM"*/


      let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis2.title.text = "production";
      // valueAxis2.title.fontWeight = 800;
      valueAxis2.renderer.opposite = true;
      valueAxis2.fontSize = 10;

      // Create series
      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "kwh";
      series.dataFields.categoryX = "day";
      series.name = 'kwh';

      series.clustered = false;
      series.tooltipText = " {legendSettings.labelText} :  {valueY}[/]";
      series.yAxis = valueAxis;
      series.fill = am4core.color('#EE5C4D');
      series.legendSettings.labelText = 'kWh';
      series.legendSettings.valueText = "{valueY.close}";
      series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";

      series.columns.template.events.on("hit", function(ev) {
          let data = ev.target.dataItem.dataContext;
          // this.drillDown(data);
          obj.drillDownProduction(data);
      }, this);

      let series2 = chart.series.push(new am4charts.ColumnSeries());
      series2.dataFields.valueY = "production";
      series2.name = 'production';
      series2.dataFields.categoryX = "day";
      series2.clustered = false;
      series2.columns.template.width = am4core.percent(40);
      series2.tooltipText = " {legendSettings.labelText} : {valueY}[/]";
      series2.yAxis = valueAxis2;
      series2.fill = am4core.color('#5D53EC');
      series2.legendSettings.labelText = 'production';
      series2.legendSettings.valueText = "{valueY.close}";
      series2.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
      series2.columns.template.events.on("hit", function(ev) {
          let data = ev.target.dataItem.dataContext;
          obj.drillDownProduction(data);
      }, this);

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.lineX.disabled = true;
      chart.cursor.lineY.disabled = true;
      chart.legend = new am4charts.Legend();
      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 14;
      markerTemplate.height = 14;
      chart.legend.fontSize = 12 

  }




  genrateProductivityPerformanceGraph_1(data) {
      /*let chart = am4core.create("pieEnergyConsumption", am4charts.PieChart);
      chart.data = [{
          "country": "Lithuania",
          "litres": 501.9
      }, {
          "country": "Czechia",
          "litres": 301.9
      }, {
          "country": "Ireland",
          "litres": 201.1
      }, {
          "country": "Germany",
          "litres": 165.8
      }, {
          "country": "Australia",
          "litres": 139.9
      }, {
          "country": "Austria",
          "litres": 128.3
      }, {
          "country": "UK",
          "litres": 99
      }, {
          "country": "Belgium",
          "litres": 60
      }, {
          "country": "The Netherlands",
          "litres": 50
      }];

      // Add and configure Series
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "litres";
      pieSeries.dataFields.category = "country";
      pieSeries.slices.template.stroke = am4core.color("#fff");
      pieSeries.slices.template.strokeWidth = 2;
      pieSeries.slices.template.strokeOpacity = 1;

      // This creates initial animation
      pieSeries.hiddenState.properties.opacity = 1;
      pieSeries.hiddenState.properties.endAngle = -90;
      pieSeries.hiddenState.properties.startAngle = -90;*/
  }

  genrateProductivityPerformanceGraph_2(data) {
   // Mothly Efficiency and Machine Performance Graph for  year: 2019
      console.log("production");
      console.log(data)
      let chart = am4core.create("barMonthlyThisConsumption", am4charts.XYChart);
      let obj = this;
      // Add data
      chart.data = data;
      /*
      chart.background.fill = am4core.color('#999');
      chart.background.opacity = 0.5*/

      /*ar label = chart.chartContainer.createChild(am4core.Label);
      label.text = " Efficiency and Machine Performance Graph for Data";
      label.align = "center";*/
      let title = chart.titles.create();
      title.text = `Mothly Efficiency and Machine Performance Graph for  year: ${data[0].year}`;
      title.fontSize = 14;
      title.marginBottom = 10;
      chart.responsive.enabled = true;
      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.renderer.labels.template.rotation = -40;
      categoryAxis.dataFields.category = "month_name";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      //categoryAxis.renderer.fontWeight = "400";
      categoryAxis.renderer.fontSize = 10;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = "Miutes";
      valueAxis.fontSize = 10; 

      //valueAxis.strictMinMax = true;
      //valueAxis.calculateTotals = true;


      let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis2.title.text = "Efficiency";
      valueAxis2.renderer.opposite = true;
      valueAxis2.fontSize = 10;



      // Create series
      function createSeries(field, name, color) {

          // Set up series
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.name = name;
          series.dataFields.valueY = field;
          series.dataFields.categoryX = "month_name";
          series.sequencedInterpolation = true;
          series.fill = am4core.color(color);
          // series.dataFields.valueYShow = "totalPercent";
          series.legendSettings.labelText = name;
          series.legendSettings.valueText = "{valueY.close}";
          series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
          series.columns.template.events.on("hit", function(ev) {
              data = ev.target.dataItem.dataContext;
              obj.drillDailyPerformance(data);
          }, this);

          // Make it stacked
          series.stacked = true;

          // Configure columns
          series.columns.template.width = am4core.percent(90);
          series.tooltipText = "{legendSettings.labelText}: {valueY}";

          // Add label
          /* var labelBullet = series.bullets.push(new am4charts.LabelBullet());
           labelBullet.label.text = "{valueY}";
           labelBullet.locationY = 0.5;*/

          return series;
      }
      // Create series
      function createSeries2(field, name, ValueAxis2, color) {

          // Set up series
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.name = name;
          series.dataFields.valueY = field;
          series.dataFields.categoryX = "month_name";
          series.fill = am4core.color(color);
          //series.sequencedInterpolation = true;

          // Make it stacked
          // series.stacked = true;
          series.clustered = false;
          series.yAxis = ValueAxis2;
          // Configure columns
          series.columns.template.width = am4core.percent(40);
          series.tooltipText = "{legendSettings.labelText}: {valueY}";
          series.legendSettings.labelText = name;
          series.legendSettings.valueText = "{valueY.close}";
          series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
          series.columns.template.events.on("hit", function(ev) {
              let data = ev.target.dataItem.dataContext;
              obj.drillDailyPerformance(data);
          }, this);

          // Add label
          /*var labelBullet = series.bullets.push(new am4charts.LabelBullet());
          labelBullet.label.text = "{''}";
          labelBullet.locationY = 0.5;*/

          return series;
      }
      createSeries("running_time", "Running time", '#218d1e');
      createSeries("off_time", "Off time", '#ff0001');
      createSeries("idle_time", "Idle_time", '#ffa304');
      createSeries2("efficiency", "Efficiency", valueAxis2, '#5b55ec');
      //
      // Legend
      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.lineX.disabled = true;
      chart.cursor.lineY.disabled = true;
      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 14;
      markerTemplate.height = 14;
      chart.legend.fontSize =14
  }
  genrateProductivityPerformanceGraph_3(data) {
      let chart = am4core.create("lineChartHrConsumption", am4charts.XYChart);
      let obj = this;
      // Add data
      chart.data = data;
      /*chart.background.fill = am4core.color('#999');
      chart.background.opacity = 0.5*/

      /*let label = chart.chartContainer.createChild(am4core.Label);
      label.text = " Efficiency and Machine Performance Graph for Data";
      label.align = "center";*/

      let title = chart.titles.create();
      title.text = ` Hourly Efficiency and Machine Performance For date : ${data[0].date}`;
      title.fontSize = 14;
      title.marginBottom = 10;

      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.renderer.labels.template.rotation = -40;
      categoryAxis.dataFields.category = "hour";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      //categoryAxis.renderer.fontWeight = "400";
      categoryAxis.renderer.fontSize = 10;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = "Miutes";
      valueAxis.fontSize = 10;

      //valueAxis.strictMinMax = true;
      // valueAxis.calculateTotals = true;


      let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis2.title.text = "Efficiency";
      valueAxis2.renderer.opposite = true;
      valueAxis2.fontSize = 10;
      chart.responsive.enabled = true;

      // Create series
      function createSeries(field, name, color) {

          // Set up series
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.name = name;
          series.dataFields.valueY = field;
          series.dataFields.categoryX = "hour";
          series.sequencedInterpolation = true;
          series.fill = am4core.color(color);
          series.legendSettings.labelText = name;
          series.legendSettings.valueText = "{valueY.close}";
          series.legendSettings.itemValueText = "{valueY}[/bold]";
          //series.dataFields.valueYShow = "totalPercent";
          series.columns.template.events.on("hit", function(ev) {
              data = ev.target.dataItem.dataContext;
              obj.drillDown(data);
          }, this);

          series.stacked = true;
          series.columns.template.width = am4core.percent(90);
          series.tooltipText = "{legendSettings.labelText}: {valueY}";

          // Add label
          /* var labelBullet = series.bullets.push(new am4charts.LabelBullet());
           labelBullet.label.text = "{valueY}";
           labelBullet.locationY = 0.5;*/

          return series;
      }
      // Create series
      function createSeries2(field, name, ValueAxis2, color) {

          // Set up series
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.name = name;
          series.dataFields.valueY = field;
          series.dataFields.categoryX = "hour";
          series.fill = am4core.color(color);
          //series.sequencedInterpolation = true;

          // Make it stacked
          // series.stacked = true;
          series.clustered = false;
          series.yAxis = ValueAxis2;
          // Configure columns
          series.columns.template.width = am4core.percent(40);
          
          series.tooltipText = "{legendSettings.labelText}: {valueY}";
          series.legendSettings.labelText = name;
          series.legendSettings.valueText = "{valueY.close}";
          series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
          series.columns.template.events.on("hit", function(ev) {
              let data = ev.target.dataItem.dataContext;
              obj.drillDown(data);
          }, this);

          // Add label
          /*var labelBullet = series.bullets.push(new am4charts.LabelBullet());
          labelBullet.label.text = "{''}";
          labelBullet.locationY = 0.5;*/

          return series;
      }
      createSeries("running_time", "Running time", '#218d1e');
      createSeries("off_time", "Off time", '#ff0001');
      createSeries("idle_time", "Idle_time", '#ffa304');
      createSeries2("efficiency", "Efficiency", valueAxis2, '#5b55ec');
      //
      // Legend
      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.lineX.disabled = true;
      chart.cursor.lineY.disabled = true;
      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 14;
      markerTemplate.height = 14;
      chart.legend.fontSize =14
  }
  genrateProductivityPerformanceGraph_4(data) {
      let chart = am4core.create("barDailyConsumptionMonthly", am4charts.XYChart);
      let obj = this;
      // Add data
      chart.data = data;
    console.log(data);
    console.log("hi");
      /*chart.background.fill = am4core.color('#999');
      chart.background.opacity = 0.5*/
      chart.responsive.enabled = true;
      /*ar label = chart.chartContainer.createChild(am4core.Label);
      label.text = " Efficiency and Machine Performance Graph for Data";
      label.align = "center";*/
      let title = chart.titles.create();
      title.text = `Efficiency and Machine Performance Graph for Month: ${data[0].month_name}`;
      title.fontSize = 14;
      title.marginBottom = 10;

     /* // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.renderer.labels.template.rotation = -40;
      categoryAxis.dataFields.category = "date";
      categoryAxis.dateFormatter.inputDateFormat = "HH:mm, d MMMM";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      //categoryAxis.renderer.fontWeight = "400";
      categoryAxis.renderer.fontSize = 10;*/

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = "Miutes";
      valueAxis.fontSize = 10;

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.minGridDistance = 60;
        chart.dateFormatter.inputDateFormat = "dd MMM"

      //valueAxis.strictMinMax = true;
      //valueAxis.calculateTotals = true;


      let valueAxis2 = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis2.title.text = "Efficiency";
      valueAxis2.renderer.opposite = true;
      valueAxis2.fontSize = 10;


      // Create series
      function createSeries(field, name, color) {

          // Set up series
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.name = name;

          series.dataFields.valueY = field;
          series.dataFields.dateX = "date";
          series.sequencedInterpolation = true;
          series.fill = am4core.color(color);
          series.legendSettings.labelText = name;
          series.legendSettings.valueText = "{valueY.close}";
          series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
          //series.dataFields.valueYShow = "totalPercent";
          series.columns.template.events.on("hit", function(ev) {
              data = ev.target.dataItem.dataContext;
              obj.drillDownPerformance(data);
          }, this);

          // Make it stacked
          series.stacked = true;

          // Configure columns
          series.columns.template.width = am4core.percent(90);
          series.tooltipText = "{legendSettings.labelText}: {valueY}";

          // Add label
          /* var labelBullet = series.bullets.push(new am4charts.LabelBullet());
           labelBullet.label.text = "{valueY}";
           labelBullet.locationY = 0.5;*/

          return series;
      }
      // Create series
      function createSeries2(field, name, ValueAxis2, color) {

          // Set up series
          var series = chart.series.push(new am4charts.ColumnSeries());
          series.name = name;
          series.dataFields.valueY = field;
          series.dataFields.dateX = "date";
          series.fill = am4core.color(color);
          //series.sequencedInterpolation = true;

          // Make it stacked
          // series.stacked = true;
          series.clustered = false;
          series.yAxis = ValueAxis2;
          // Configure columns
          series.columns.template.width = am4core.percent(40);
          series.tooltipText = "{legendSettings.labelText}: {valueY}";
          series.legendSettings.labelText = name;
          series.legendSettings.valueText = "{valueY.close}";
          series.legendSettings.itemValueText = "[bold]{valueY}[/bold]";
          series.columns.template.events.on("hit", function(ev) {
              let data = ev.target.dataItem.dataContext;
              obj.drillDownPerformance(data);
          }, this);

          // Add label
          /*var labelBullet = series.bullets.push(new am4charts.LabelBullet());
          labelBullet.label.text = "{''}";
          labelBullet.locationY = 0.5;*/

          return series;
      }
      createSeries("running_time", "Running time", '#218d1e');
      createSeries("off_time", "Off time", '#ff0001');
      createSeries("idle_time", "Idle_time", '#ffa304');
      createSeries2("efficiency", "Efficiency", valueAxis2, '#5b55ec');
      //

      chart.legend = new am4charts.Legend();
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.lineX.disabled = true;
      chart.cursor.lineY.disabled = true;
      var markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 14;
      markerTemplate.height = 14;
      chart.legend.fontSize =14
  }


  getliveChartsData() {
      this._getLiveDataForCharts.getLiveDataProductvity().subscribe(
          data => this.getLiveData(data),
          error => console.error(error)
      );
  }
  getLiveData(data) {

      this.performanceData(data.data.performance);
      this.productionData(data.data.production);
  }

  setDataForAllProductyvityProductionCharts(data) {
      console.log(data);
     // this.genrateProductivityProductionGraph_1(data.data.monthly.data.linechart);
      this.genrateProductivityProductionGraph_2(data.data.monthly.data.linechart);
      this.genrateProductivityProductionGraph_3(data.data.hourly.data.linechart);
      this.genrateProductivityProductionGraph_4(data.data.daily.data.linechart);
  }

  setDataForAllProductyvityPerformanceCharts(data) {
      console.log(data);
      this.genrateProductivityPerformanceGraph_1(data.data.monthly.data.linechart);
      this.genrateProductivityPerformanceGraph_2(data.data.monthly.data.linechart);
      this.genrateProductivityPerformanceGraph_3(data.data.hourly.data.linechart);
      this.genrateProductivityPerformanceGraph_4(data.data.daily.data.linechart);
  }

  generateEnergyAllGroupCharts(data) {
      console.log('generateEnergyAllGroupCharts', data)
      if (data.type == 'performance') {
          this.title = data.name
          //this.categoryData.currentMessage.subscribe(message => this.selected_category_data = message)
          return this._networkService.getProductionAllChartData(data).subscribe(
              data => this.setDataForAllProductyvityPerformanceCharts(data),
              error => console.error(error)
          );
      } else if (data.type == 'production') {
          console.log('production', data)
          this.title = data.name
          //this.categoryData.currentMessage.subscribe(message => this.selected_category_data = message)
          return this._networkService.getProductivityAllChartData(data).subscribe(
              data => this.setDataForAllProductyvityProductionCharts(data),
              error => console.error(error)
          );
      }
  }

  performanceData(data) {
      console.log(data);
      this.effAllMachine(data);
  }
  productionData(data) {
      this.prodAllmachine(data);
  }
}